/** @format */

import { ProcureMode } from '@shared/data-access/enums';

export interface Tip {
  procure: ProcureMode.SAMEDAY;
  sku: string;
  tip_amount: string;
}

export interface CheckoutPaymentPricing {
  currency: string;
  external_key?: string;
  external_souce?: string;
  total: string;
  total_delivery: string;
  total_discounts: string;
  total_remaining?: string;
  total_shipping: string;
  total_tax: string;
  total_tip?: string;
  total_unit: string;
}
